/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Advisor } from './Advisor';
import {
    AdvisorFromJSON,
    AdvisorFromJSONTyped,
    AdvisorToJSON,
} from './Advisor';
import type { AuthProgram } from './AuthProgram';
import {
    AuthProgramFromJSON,
    AuthProgramFromJSONTyped,
    AuthProgramToJSON,
} from './AuthProgram';
import type { JobSearchData } from './JobSearchData';
import {
    JobSearchDataFromJSON,
    JobSearchDataFromJSONTyped,
    JobSearchDataToJSON,
} from './JobSearchData';
import type { LinkedinLearningAccount } from './LinkedinLearningAccount';
import {
    LinkedinLearningAccountFromJSON,
    LinkedinLearningAccountFromJSONTyped,
    LinkedinLearningAccountToJSON,
} from './LinkedinLearningAccount';
import type { MemberType } from './MemberType';
import {
    MemberTypeFromJSON,
    MemberTypeFromJSONTyped,
    MemberTypeToJSON,
} from './MemberType';
import type { Process } from './Process';
import {
    ProcessFromJSON,
    ProcessFromJSONTyped,
    ProcessToJSON,
} from './Process';

/**
 * 
 * @export
 * @interface IAuthMember
 */
export interface IAuthMember {
    /**
     * 
     * @type {string}
     * @memberof IAuthMember
     */
    userName?: string;
    /**
     * 
     * @type {MemberType}
     * @memberof IAuthMember
     */
    memberType?: MemberType;
    /**
     * 
     * @type {string}
     * @memberof IAuthMember
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof IAuthMember
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IAuthMember
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof IAuthMember
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof IAuthMember
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof IAuthMember
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof IAuthMember
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof IAuthMember
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof IAuthMember
     */
    email?: string;
    /**
     * 
     * @type {JobSearchData}
     * @memberof IAuthMember
     */
    jobSearchProfile?: JobSearchData;
    /**
     * 
     * @type {boolean}
     * @memberof IAuthMember
     */
    isCandidateProxyLogin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IAuthMember
     */
    canEditUserName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IAuthMember
     */
    canEditPersonalData?: boolean;
    /**
     * 
     * @type {LinkedinLearningAccount}
     * @memberof IAuthMember
     */
    linkedinLearningAccount?: LinkedinLearningAccount;
    /**
     * 
     * @type {Process}
     * @memberof IAuthMember
     */
    progress?: Process;
    /**
     * 
     * @type {AuthProgram}
     * @memberof IAuthMember
     */
    program?: AuthProgram;
    /**
     * 
     * @type {Array<AuthProgram>}
     * @memberof IAuthMember
     */
    programmes?: Array<AuthProgram>;
    /**
     * 
     * @type {number}
     * @memberof IAuthMember
     */
    jobInterviews?: number;
    /**
     * 
     * @type {Advisor}
     * @memberof IAuthMember
     */
    advisor?: Advisor;
    /**
     * 
     * @type {Array<Advisor>}
     * @memberof IAuthMember
     */
    secondaryAdvisors?: Array<Advisor>;
    /**
     * 
     * @type {boolean}
     * @memberof IAuthMember
     */
    temporaryPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IAuthMember
     */
    allowTracking?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IAuthMember
     */
    consentTracking?: boolean;
}

/**
 * Check if a given object implements the IAuthMember interface.
 */
export function instanceOfIAuthMember(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IAuthMemberFromJSON(json: any): IAuthMember {
    return IAuthMemberFromJSONTyped(json, false);
}

export function IAuthMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAuthMember {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userName': !exists(json, 'UserName') ? undefined : json['UserName'],
        'memberType': !exists(json, 'MemberType') ? undefined : MemberTypeFromJSON(json['MemberType']),
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'firstName': !exists(json, 'FirstName') ? undefined : json['FirstName'],
        'country': !exists(json, 'Country') ? undefined : json['Country'],
        'countryCode': !exists(json, 'CountryCode') ? undefined : json['CountryCode'],
        'address': !exists(json, 'Address') ? undefined : json['Address'],
        'zipCode': !exists(json, 'ZipCode') ? undefined : json['ZipCode'],
        'language': !exists(json, 'Language') ? undefined : json['Language'],
        'email': !exists(json, 'Email') ? undefined : json['Email'],
        'jobSearchProfile': !exists(json, 'JobSearchProfile') ? undefined : JobSearchDataFromJSON(json['JobSearchProfile']),
        'isCandidateProxyLogin': !exists(json, 'IsCandidateProxyLogin') ? undefined : json['IsCandidateProxyLogin'],
        'canEditUserName': !exists(json, 'CanEditUserName') ? undefined : json['CanEditUserName'],
        'canEditPersonalData': !exists(json, 'CanEditPersonalData') ? undefined : json['CanEditPersonalData'],
        'linkedinLearningAccount': !exists(json, 'LinkedinLearningAccount') ? undefined : LinkedinLearningAccountFromJSON(json['LinkedinLearningAccount']),
        'progress': !exists(json, 'Progress') ? undefined : ProcessFromJSON(json['Progress']),
        'program': !exists(json, 'Program') ? undefined : AuthProgramFromJSON(json['Program']),
        'programmes': !exists(json, 'Programmes') ? undefined : ((json['Programmes'] as Array<any>).map(AuthProgramFromJSON)),
        'jobInterviews': !exists(json, 'JobInterviews') ? undefined : json['JobInterviews'],
        'advisor': !exists(json, 'Advisor') ? undefined : AdvisorFromJSON(json['Advisor']),
        'secondaryAdvisors': !exists(json, 'SecondaryAdvisors') ? undefined : ((json['SecondaryAdvisors'] as Array<any>).map(AdvisorFromJSON)),
        'temporaryPassword': !exists(json, 'TemporaryPassword') ? undefined : json['TemporaryPassword'],
        'allowTracking': !exists(json, 'AllowTracking') ? undefined : json['AllowTracking'],
        'consentTracking': !exists(json, 'ConsentTracking') ? undefined : json['ConsentTracking'],
    };
}

export function IAuthMemberToJSON(value?: IAuthMember | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'UserName': value.userName,
        'MemberType': MemberTypeToJSON(value.memberType),
        'Name': value.name,
        'FirstName': value.firstName,
        'Country': value.country,
        'CountryCode': value.countryCode,
        'Address': value.address,
        'ZipCode': value.zipCode,
        'Language': value.language,
        'Email': value.email,
        'JobSearchProfile': JobSearchDataToJSON(value.jobSearchProfile),
        'IsCandidateProxyLogin': value.isCandidateProxyLogin,
        'CanEditUserName': value.canEditUserName,
        'CanEditPersonalData': value.canEditPersonalData,
        'LinkedinLearningAccount': LinkedinLearningAccountToJSON(value.linkedinLearningAccount),
        'Progress': ProcessToJSON(value.progress),
        'Program': AuthProgramToJSON(value.program),
        'Programmes': value.programmes === undefined ? undefined : ((value.programmes as Array<any>).map(AuthProgramToJSON)),
        'JobInterviews': value.jobInterviews,
        'Advisor': AdvisorToJSON(value.advisor),
        'SecondaryAdvisors': value.secondaryAdvisors === undefined ? undefined : ((value.secondaryAdvisors as Array<any>).map(AdvisorToJSON)),
        'TemporaryPassword': value.temporaryPassword,
        'AllowTracking': value.allowTracking,
        'ConsentTracking': value.consentTracking,
    };
}

